import { AbstractProjectAdministrativeItemController } from "@/controllers/model-controllers/abstract/abstract-project-administrative-item-controller"
import { ProjectRentalDispenseItem } from "@/models/project-rental-dispense-item.model"
import { type IProjectRentalDispenseItem } from "@/interfaces/api/project-rental-dispense-item.interface"
import { ProjectRentalDispenseItemRepository } from "@/repositories/project-rental-dispense-item.repository"
import { useProjectsRentalDispenseItemsStore } from "@/store/projects-rental-dispense-items.store"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { storeToRefs } from "pinia"

export class ProjectRentalDispenseItemController extends AbstractProjectAdministrativeItemController<
  ProjectRentalDispenseItem,
  IProjectRentalDispenseItem,
  ProjectRentalDispenseItemRepository
> {
  constructor() {
    const projectsRentalDispenseItemsStore = useProjectsRentalDispenseItemsStore()
    const { projectsRentalDispenseItems } = storeToRefs(projectsRentalDispenseItemsStore)
    const storeFunctionsConfig = {
      collection: projectsRentalDispenseItems
    }

    super(
      ProjectRentalDispenseItem,
      storeFunctionsConfig,
      new ProjectRentalDispenseItemRepository()
    )
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      ProjectRentalDispenseItem,
      projectsRentalDispenseItems
    )
  }
}
